import React, { useCallback, useEffect, useState } from "react";
import {
  Alert,
  Button,
  Tabs,
  Tab,
  Col,
  Row,
  Spinner,
  Card,
  Form,
  InputGroup,
} from "react-bootstrap";
import Modal from "../../../Utilities/DraggableModal";
import PaymentHistoryForm from "../../PaymentHistoryPopup/PaymentHistoryForm";
import Comments from "../../../AccountDetailsPopup/AccordionItems/Comments";
import AdverseCarrierDropdown from "../../AdverseCarrier/AdverseCarrierDropdown";
import FormRow from "../../FormRow";
import useFetch from "../../../Utilities/useFetch";
import SkipTraceToggleCheckbox from "../../SkipTraceToggleCheckbox";
import AdverseCarrierForm from "../../AdverseCarrier/AdverseCarrierForm";
import StatusChangeModal from "../../StatusChangeModal";
import { useMsal } from "@azure/msal-react";
import funcFetch from "../../../Utilities/funcFetch";
import ErrorBoundary from "../../../Auth/ErrorBoundary";
import Financial from "./Financial/Financial";
import PersonalFinancial from "./Financial/PersonalFinancial";
import General from "./General/General";
import Arbitration from "./Arbitration/Arbitration";
import LanguageSelect from "./LanguageSelect";
import IncreaseContactCountButton from "./General/IncreaseContactCountButton";
import { FaBook, FaMagic, FaSms } from "react-icons/fa";
import { GiAudioCassette } from "react-icons/gi";
import { BsArrowsFullscreen } from "react-icons/bs";
import AudioTranscriptsOnlyModal from "./General/AudioTranscriptsOnlyModal";
import AddressHistoryModal from "./General/AddressHistoryModal";
import DebtorSMSHistoryModal from "./General/DebtorSMSHistoryModal";
import ShowTranscriptsModal from "./General/ShowTranscriptsModal";
import ClaimDocuments from "./Docs/ClaimDocuments";

const CollectorClaimView = ({
  claimNumber,
  loading,
  activities,
  setActivities,
  account,
  setAccount,
  reloadClaim,
  updateAccountFieldsAndActivities,
}) => {
  const { REACT_APP_API_URL } = process.env;
  const { data: isPaymentAdmin, loading: loadingIsPaymentAdmin } = useFetch(
    true,
    `${REACT_APP_API_URL}/Claims/IsPaymentAdmin`,
    "GET"
  );
  const { data: projects, loading: loadingProjects } = useFetch(
    true,
    `${REACT_APP_API_URL}/Claims/GetProjects`,
    "GET"
  );
  const { data: isClaimCreator } = useFetch(
    true,
    `${REACT_APP_API_URL}/Claims/isClaimCreator`,
    "GET"
  );
  const [projectOptions, setProjectOptions] = useState();
  const [selectedClient] = useState();
  const { instance, accounts } = useMsal();
  const [selectedAdverseCarrier, setSelectedAdverseCarrier] = useState();
  const [statusChangeIsOpen, setStatusChangeIsOpen] = useState(false);
  const [postingData, setPostingData] = useState(false);
  const [APIResponse, setAPIResponse] = useState();
  const [APIError, setAPIError] = useState();
  const [readOnly] = useState(false);
  const [key, setKey] = useState("general");
  const [addressHistoryOpen, setAddressHistoryOpen] = useState(false);
  const [showTranscriptsOpen, setShowTranscriptsOpen] = useState(false);
  const [audioTranscriptsOnlyOpen, setAudioTranscriptsOnlyOpen] = useState(false);
  const [smsHistoryOpen, setSmsHistoryOpen] = useState(false);
  const [templatingClaim, setTemplatingClaim] = useState(false);
  const [pendingTemplateAccount, setPendingTemplateAccount] = useState(null);
  const [templateMessage, setTemplateMessage] = useState("");
  const [mailStatusReason, setMailStatusReason] = useState("");
  const [showPaymentFormPopup, setShowPaymentFormPopup] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const mailStatusOptions = [
    "Not Delivered as Addressed (NDAA)",
    "Attempted Not Known (ANK)",
    "Vacant",
    "Refused",
    "Forward Order Expired",
    "Unclaimed",
    "No Such Number (NSN)",
    "No Such Street (NSS)",
    "Insufficient Address (ISA)",
    "Moved Left Not Address",
    "Addressee Unknown",
    "Unable to Forward (UTF)",
    "No Mail Receptacle",
    "Deceased",
  ];
  const aYearFromNow = new Date(
    new Date().setFullYear(new Date().getFullYear() + 1)
  )
    .toISOString()
    .split("T")[0];

  useEffect(() => {
    if (projects) {
      setProjectOptions(
        projects.map((project) => {
          return { value: project.key, label: project.value };
        })
      );
    }
  }, [projects]);

  useEffect(() => {
    if (claimNumber) {
      setAPIError(null);
      setAPIResponse(null);
      setSelectedAdverseCarrier(null);
    }
  }, [claimNumber]);

  useEffect(() => {
    const accountMailReturned =
      account?.account?.mailreturned ??
      account?.account?.mailReturned ??
      account?.mailreturned ??
      account?.mailReturned ??
      null;

    setMailStatusReason(accountMailReturned == null ? "" : String(accountMailReturned));
  }, [
    account?.account?.mailreturned,
    account?.account?.mailReturned,
    account?.mailreturned,
    account?.mailReturned,
  ]);

  const handleChange = (valueName, value) => {
    const normalizedValueName = valueName.toLowerCase();

    if (normalizedValueName.includes("date") && value === "") {
      value = null;
    }
    setAPIError(null);
    setAPIResponse(null);
    let newAccountObj = { ...account };

    if (
      normalizedValueName === "arbitrationdecision" ||
      normalizedValueName === "arbitrationdecison"
    ) {
      const arbitrationDecisionValue = value || {};
      newAccountObj.arbitrationDecision = arbitrationDecisionValue;
      newAccountObj.arbitrationdecision = arbitrationDecisionValue;
      newAccountObj.account.arbitrationDecision = arbitrationDecisionValue;
      newAccountObj.account.arbitrationdecision = arbitrationDecisionValue;
      setAccount(newAccountObj);
      return;
    }

    newAccountObj.account[valueName] = value;
    setAccount(newAccountObj);
  };

  const handlePersonalFinancialChange = (valueName, value) => {
    setAPIError(null);
    setAPIResponse(null);
    let newAccountObj = { ...account };
    if (newAccountObj.personalFinancial === null) {
      newAccountObj.personalFinancial = {};
    }
    newAccountObj.personalFinancial[valueName] = value;
    setAccount(newAccountObj);
  };

  const handleFinancialChange = (valueName, value) => {
    setAPIError(null);
    setAPIResponse(null);
    let newAccountObj = { ...account };
    newAccountObj.account[valueName] = value;
    newAccountObj.financial[valueName] = value;
    setAccount(newAccountObj);
  };

  const handleSubmit = (e) => {
    setPostingData(true);
    setAPIError(null);
    setAPIResponse(null);
    e.preventDefault();
    if (claimNumber) {
      funcFetch(
        `${REACT_APP_API_URL}/Claims/PostAccount`,
        null,
        "POST",
        {
          account: account.account,
          financial: account.financial,
          personalFinancial: account.personalFinancial,
        },
        instance,
        accounts
      )
        .then((response) => {
          setPostingData(false);
          setAPIResponse("Successfully saved changes");
          setAccount(response);
          updateAccountFieldsAndActivities({activities: response.activities});
        })
        .catch((err) => {
          console.error(err);
          setAPIError("There was an issue, please try again.");
          setPostingData(false);
        });
    } else {
      funcFetch(
        `${REACT_APP_API_URL}/Claims/GenerateDebtorid`,
        {
          clientID: selectedClient.value.clientID,
          clientRefNo: account.account.clientRefNo,
        },
        "POST",
        {},
        instance,
        accounts
      ).then((debtorID) => {
        account.account.debtorID = debtorID;
        setAccount(account);
        funcFetch(
          `${REACT_APP_API_URL}/Claims/PostAccount`,
          null,
          "POST",
          { account: account.account, financial: account.financial },
          instance,
          accounts
        )
          .then((response) => {
            setPostingData(false);
          })
          .catch((error) => {
            setAPIError("There was an issue, please try again.");
            console.error(error);
            setPostingData(false);
          });
      });
    }
  };

  const hasTranscripts = Boolean(account?.hasTranscripts);

  const refreshDebtorActivityNotes = useCallback(
    (debtorID) => {
      if (!debtorID) {
        return Promise.resolve();
      }

      return funcFetch(
        `${REACT_APP_API_URL}/Claims/GetAccountDetail`,
        { debtorid: debtorID },
        "GET",
        null,
        instance,
        accounts
      )
        .then((response) => {
          if (response?.activities) {
            setActivities(response.activities);
          }
        })
        .catch((err) => {
          console.error("Failed to refresh debtor activity notes", err);
        });
    },
    [REACT_APP_API_URL, instance, accounts, setActivities]
  );

  const handleHideTranscripts = () => {
    setShowTranscriptsOpen(false);

    const currentDebtorId = account?.account?.debtorID;
    if (!currentDebtorId) return;

    if (reloadClaim) {
      reloadClaim(currentDebtorId);
      return;
    }

    refreshDebtorActivityNotes(currentDebtorId);
  };

  const handleTemplateClaim = () => {
    const debtorId = account?.account?.debtorID;
    if (!debtorId) {
      setAPIError("A debtor ID is required before the claim can be templated.");
      return;
    }

    setTemplatingClaim(true);
    setAPIError(null);
    setAPIResponse(null);

    funcFetch(
      `${REACT_APP_API_URL}/claims/TemplateClaim`,
      { debtorId },
      "POST",
      null,
      instance,
      accounts
    )
      .then((response) => {
        const templateAccount = response?.Account ?? response?.account;
        if (!templateAccount) {
          throw new Error("TemplateClaim did not return an Account.");
        }

        setPendingTemplateAccount(templateAccount);
        setTemplateMessage(response?.Message ?? response?.message ?? "");
      })
      .catch((err) => {
        console.error("Failed to template claim", err);
        setAPIError("There was an issue applying the claim template. Please try again.");
      })
      .finally(() => {
        setTemplatingClaim(false);
      });
  };

  const handleConfirmTemplateClaim = () => {
    setAccount((currentAccount) => ({
      ...currentAccount,
      account: pendingTemplateAccount,
    }));
    if (pendingTemplateAccount?.activities) {
      setActivities(pendingTemplateAccount.activities);
    }
    setPendingTemplateAccount(null);
    setTemplateMessage("");
    setAPIResponse("Claim template applied.");
  };

  const handleCancelTemplateClaim = () => {
    setPendingTemplateAccount(null);
    setTemplateMessage("");
  };

  const handleOpenPaymentFormPopup = (payment) => {
    setSelectedPayment(payment);
    setShowPaymentFormPopup(true);
  };

  const handleClosePaymentFormPopup = () => {
    setShowPaymentFormPopup(false);
    setSelectedPayment(null);
  };

  const formatPaymentDate = (dateValue) => {
    if (!dateValue) {
      return "No date";
    }

    const dateObj = new Date(dateValue);
    if (Number.isNaN(dateObj.getTime())) {
      return "No date";
    }

    return dateObj.toLocaleDateString();
  };

  const formatPaymentAmount = (amount) => {
    const numericAmount = Number(amount);

    if (!Number.isFinite(numericAmount)) {
      return "N/A";
    }

    return numericAmount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  };

  const isNewPaymentEntry = (payment) => {
    if (!payment) {
      return true;
    }

    if (Object.keys(payment).length === 0) {
      return true;
    }

    return payment.paymentID === 0;
  };

  const normalizeAccountDetailForClaimView = useCallback((accountDetail) => {
    if (!accountDetail || typeof accountDetail !== "object") {
      return accountDetail;
    }

    const normalizedAccountDetail = { ...accountDetail };
    const paymentHistory = Array.isArray(accountDetail.paymentHistory)
      ? [...accountDetail.paymentHistory]
      : [];

    if (paymentHistory.length === 0) {
      normalizedAccountDetail.paymentHistory = [{}];
      return normalizedAccountDetail;
    }

    if (paymentHistory[0] == null) {
      paymentHistory[0] = {};
    } else {
      const firstPayment = paymentHistory[0];
      const hasCreateRow =
        typeof firstPayment === "object" && Object.keys(firstPayment).length === 0;

      if (!hasCreateRow) {
        paymentHistory.unshift({});
      }
    }

    normalizedAccountDetail.paymentHistory = paymentHistory;
    return normalizedAccountDetail;
  }, []);

  const handleMailStatusReasonChange = (selectedReason) => {
    setMailStatusReason(selectedReason);

    if (!selectedReason) {
      return;
    }

    const debtorID = account?.account?.debtorID;
    if (!debtorID) {
      setAPIError("Debtor ID is required.");
      return;
    }

    setAPIError(null);
    setAPIResponse(null);

    funcFetch(
      `${REACT_APP_API_URL}/Claims/MailReturnedCheck`,
      null,
      "POST",
      {
        debtorID,
        reason: selectedReason,
      },
      instance,
      accounts
    )
      .then((response) => {
        const normalizedResponse = normalizeAccountDetailForClaimView(response);

        setAPIResponse("Mail returned status saved.");

        if (normalizedResponse?.account) {
          setAccount(normalizedResponse);
        }

        if (normalizedResponse?.activities) {
          setActivities(normalizedResponse.activities);
        }
      })
      .catch((err) => {
        console.error(err);
        setAPIError("There was an issue, please try again.");
      });
  };

  const paymentRows =
    account.paymentHistory && account.paymentHistory.length > 0
      ? account.paymentHistory
      : [{}];

  const aiSummary =
    account?.aiSummaryHistory ??
    account?.aisummaryhistory ??
    account?.aiSummary ??
    account?.aisummary ??
    account?.account?.aiSummaryHistory ??
    account?.account?.aisummaryhistory ??
    account?.account?.aiSummary ??
    account?.account?.aisummary ??
    account?.accountDetail?.aiSummary ??
    account?.accountDetail?.aiSummaryHistory ??
    account?.accountDetail?.aisummaryhistory ??
    account?.accountDetail?.aisummary ??
    account?.accountdetail?.aiSummary ??
    account?.accountdetail?.aiSummaryHistory ??
    account?.accountdetail?.aisummaryhistory ??
    account?.accountdetail?.aisummary ??
    "";

  const documents =
    account?.subroDocuments ??
    account?.accountDetail?.subroDocuments ??
    account?.accountdetail?.subroDocuments ??
    [];

  const documentDebtorId =
    account?.accountDetails?.Account?.debtorid ??
    account?.accountDetails?.account?.debtorid ??
    account?.account?.debtorid ??
    account?.account?.debtorID;

  return (
    <>
      {statusChangeIsOpen ? (
        <StatusChangeModal
          show={statusChangeIsOpen}
          setShow={setStatusChangeIsOpen}
          account={account}
          setAccount={setAccount}
          updateAccountFieldsAndActivities={updateAccountFieldsAndActivities}
        />
      ) : null}
      <DebtorSMSHistoryModal
        show={smsHistoryOpen}
        onHide={() => setSmsHistoryOpen(false)}
        smsHistory={account?.debtorSMSHistory}
        debtorID={account?.account?.debtorID}
      />
      {audioTranscriptsOnlyOpen && (
        <AudioTranscriptsOnlyModal
          show={audioTranscriptsOnlyOpen}
          onHide={() => setAudioTranscriptsOnlyOpen(false)}
          debtorID={account.account?.debtorID}
        />
      )}
      <ErrorBoundary>
        <Row className="claim-lookup-wrapper">
          <Col md={key === "docs" ? 12 : undefined}>
            <form id="claim-info" onSubmit={(e) => handleSubmit(e)}>
              {loading ? (
                <Alert>
                  Getting claim info <Spinner animation="border" size="sm" />
                </Alert>
              ) : (
                account.financial && (
                  <>
                    <FormRow className="light-grey-background">
                      <h6>Skip Trace</h6>
                      <div className="skip-trace-wrapper">
                        <div className="skip-trace-row">
                          <Form.Label>Needed</Form.Label>
                          <SkipTraceToggleCheckbox
                            readOnly={readOnly}
                            defaultChecked={account.accountFlags?.skipTraceNeeded}
                            debtorid={account.account?.debtorID}
                            updateAccountFieldsAndActivities={
                              updateAccountFieldsAndActivities
                            }
                          />
                          <Form.Label>Completed</Form.Label>
                          <Form.Check
                            readOnly
                            checked={account.accountFlags?.skipTraceCompleted}
                          />
                          <Form.Control
                            className="skip-trace-date-input"
                            disabled
                            value={
                              account.accountFlags?.skipTraceDate?.split("T")[0]
                            }
                            type="date"
                          />
                          <LanguageSelect
                            account={account}
                            setAccount={setAccount}
                            updateAccountFieldsAndActivities={
                              updateAccountFieldsAndActivities
                            }
                          />
                          <InputGroup style={{ width: "75px" }}>
                            <Form.Control
                              value={account.account?.contactCount}
                              type="number"
                              readOnly
                              style={{ width: "30px" }}
                            />
                            <IncreaseContactCountButton
                              debtorID={account.account?.debtorID}
                              instance={instance}
                              accounts={accounts}
                              setAccount={setAccount}
                              updateAccountFieldsAndActivities={updateAccountFieldsAndActivities}
                            />
                          </InputGroup>
                        </div>
                        <div className="skip-trace-row">
                          <Button
                            variant="secondary"
                            className="ms-2"
                            onClick={() => setAddressHistoryOpen(true)}
                            title="View Address History"
                            style={{ marginLeft: "10px" }}
                          >
                            <FaBook />
                          </Button>
                          <Form.Select
                            className="ms-2"
                            aria-label="Mail status reason"
                            value={mailStatusReason}
                            onChange={(e) =>
                              handleMailStatusReasonChange(e.target.value)
                            }
                            style={{ width: "280px" }}
                          >
                            <option value="">Select Mail Status</option>
                            {mailStatusOptions.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </Form.Select>
                          <Button
                            variant="secondary"
                            className="ms-2"
                            onClick={() => setSmsHistoryOpen(true)}
                            title="View SMS History"
                          >
                            <FaSms />
                          </Button>
                          <Button
                            type="button"
                            variant="secondary"
                            className="ms-2"
                            onClick={() => setAudioTranscriptsOnlyOpen(true)}
                            title="View Audio Transcripts"
                            style={{ backgroundColor: "white" }}
                          >
                            <GiAudioCassette style={{ color: "#0d6efd" }} />
                          </Button>
                          <Button
                            type="button"
                            variant="secondary"
                            className="ms-2"
                            onClick={handleTemplateClaim}
                            disabled={templatingClaim}
                            title="Apply Claim Template"
                            aria-label="Apply Claim Template"
                          >
                            {templatingClaim ? (
                              <Spinner animation="border" size="sm" />
                            ) : (
                              <FaMagic />
                            )}
                          </Button>
                        </div>
                      </div>
                    </FormRow>
                    <Tabs
                      id="controlled-tab-example"
                      activeKey={key}
                      onSelect={(k) => setKey(k)}
                      className="mb-3"
                    >
                      <Tab eventKey="general" title="General">
                        <General
                          account={account}
                          setAccount={setAccount}
                          handleChange={handleChange}
                          handleFinancialChange={handleFinancialChange}
                          updateAccountFieldsAndActivities={
                            updateAccountFieldsAndActivities
                          }
                          isClaimCreator={isClaimCreator}
                          projectOptions={projectOptions}
                          loadingProjects={loadingProjects}
                          setStatusChangeIsOpen={setStatusChangeIsOpen}
                          readOnly={readOnly}
                        />
                        <FormRow>
                          <Button type="submit">
                            {postingData ? (
                              <Spinner animation="border" size="sm" />
                            ) : (
                              "Save Changes"
                            )}
                          </Button>
                          {APIResponse ? <Alert>{APIResponse}</Alert> : null}

                          {APIError ? (
                            <Alert variant="warning">{APIError}</Alert>
                          ) : null}
                        </FormRow>
                      </Tab>

                      <Tab eventKey="financial" title="Financial">
                        <FormRow className="black-outline">
                          <Financial
                            account={account}
                            handleFinancialChange={handleFinancialChange}
                            handleChange={handleChange}
                            updateAccountFieldsAndActivities={
                              updateAccountFieldsAndActivities
                            }
                            readOnly={readOnly}
                            isClaimCreator={isClaimCreator}
                            aYearFromNow={aYearFromNow}
                          />
                        </FormRow>
                        <FormRow className="black-outline">
                          <PersonalFinancial
                            personalFinancialData={account.personalFinancial}
                            handlePersonalFinancialChange={
                              handlePersonalFinancialChange
                            }
                            readOnly={readOnly}
                          />
                        </FormRow>
                        <FormRow>
                          <Button type="submit">
                            {postingData ? (
                              <Spinner animation="border" size="sm" />
                            ) : (
                              "Save Changes"
                            )}
                          </Button>
                          {APIResponse ? <Alert>{APIResponse}</Alert> : null}

                          {APIError ? (
                            <Alert variant="warning">{APIError}</Alert>
                          ) : null}
                        </FormRow>
                      </Tab>

                      <Tab eventKey="arbitration" title="Arbitration">
                        <FormRow className="black-outline">
                          <Arbitration
                            arbitration={account.account}
                            arbitrationDecision={account.arbitrationDecision || account.arbitrationdecision}
                            handleChange={handleChange}
                            readOnly={readOnly}
                            aYearFromNow={aYearFromNow}
                            debtorID={account.account?.debtorID}
                          />
                        </FormRow>
                        <FormRow>
                          <Button type="submit">
                            {postingData ? (
                              <Spinner animation="border" size="sm" />
                            ) : (
                              "Save Changes"
                            )}
                          </Button>
                          {APIResponse ? <Alert>{APIResponse}</Alert> : null}

                          {APIError ? (
                            <Alert variant="warning">{APIError}</Alert>
                          ) : null}
                        </FormRow>
                      </Tab>

                      <Tab eventKey="adverseCarrier" title="Adverse Carrier">
                        <FormRow className="adverse-carrier-dropdown">
                          <Form.Label>Adverse Carrier</Form.Label>
                          <AdverseCarrierDropdown
                            adverseCarriers={account.adverseCarriers}
                            selectedAdverseCarrier={selectedAdverseCarrier}
                            setSelectedAdverseCarrier={
                              setSelectedAdverseCarrier
                            }
                          />
                          <Button
                            onClick={() =>
                              setSelectedAdverseCarrier({
                                value: {
                                  adverseCarrierID: 0,
                                  debtorid: account.account.debtorID,
                                  adverseCarrier: "",
                                  adverseAdjuster: "",
                                  address1: "",
                                  address2: "",
                                  city: "",
                                  state: "",
                                  zip: "",
                                  tel1: "",
                                  ext1: "",
                                  tel2: "",
                                  ext2: "",
                                  fax: "",
                                  claim: "",
                                  tpa: "",
                                  email: "",
                                  email1: "",
                                  email2: "",
                                  subDemandSent: false,
                                  policyHolder: "",
                                  denialOfCoverage: false,
                                  denialOfLiability: false,
                                },
                              })
                            }
                          >
                            Add New
                          </Button>
                        </FormRow>
                        {selectedAdverseCarrier ? (
                          <AdverseCarrierForm
                            className={"black-outline"}
                            adverseCarrier={selectedAdverseCarrier.value}
                            updateAccountFieldsAndActivities={
                              updateAccountFieldsAndActivities
                            }
                          />
                        ) : null}
                        <FormRow>
                          {APIResponse ? <Alert>{APIResponse}</Alert> : null}

                          {APIError ? (
                            <Alert variant="warning">{APIError}</Alert>
                          ) : null}
                        </FormRow>
                      </Tab>

                      <Tab eventKey="docs" title="Docs">
                        <ClaimDocuments
                          debtorid={documentDebtorId}
                          documents={documents}
                          onUploaded={reloadClaim}
                        />
                      </Tab>
                    </Tabs>
                  </>
                )
              )}
            </form>
          </Col>
          {key !== "docs" && (
          <Col>
            {claimNumber ? (
              <div className="margin-top margin-bottom">
                <div>
                  {activities ? (
                    <Card>
                      <Comments
                        activities={activities}
                        setActivities={setActivities}
                        debtorID={account.account?.debtorID}
                        account={account.account}
                        aiSummary={aiSummary}
                        onOpenTranscripts={() => setShowTranscriptsOpen(true)}
                        hasTranscripts={hasTranscripts}
                        updateAccountFieldsAndActivities={
                          updateAccountFieldsAndActivities
                        }
                      />
                    </Card>
                  ) : (
                    <Spinner animation="border" />
                  )}
                </div>
                <Card className="payment-history-wrapper margin-top">
                  {projects && !loadingIsPaymentAdmin
                    ? paymentRows.map((payment, index) => {
                        const isNewEntry = isNewPaymentEntry(payment);
                        return (
                          <div
                            className="individual-payment-wrapper payment-history-item"
                            key={payment.paymentID || `${payment.paymentDate || "payment"}-${index}`}
                          >
                            <div className="payment-history-item-header">
                              <div>
                                {isNewEntry ? (
                                  <strong>Create New Payment Entry</strong>
                                ) : (
                                  <>
                                    <strong>Payment Date:</strong> {formatPaymentDate(payment.paymentDate)}
                                    {" | "}
                                    <strong>Amount:</strong> {formatPaymentAmount(payment.paymentAmount)}
                                    {" | "}
                                    <strong>Status:</strong> {payment.checkStatus || "N/A"}
                                    {" | "}
                                    <strong>Deposit Date:</strong> {formatPaymentDate(payment.deposit_Date)}
                                    {" | "}
                                    <strong>Payment Type:</strong> {payment.paymentMethod || "N/A"}
                                    {" | "}
                                    <strong>Collection Type:</strong> {payment.collection_Type || "N/A"}
                                    {" | "}
                                    <strong>Collector:</strong> {payment.collector || "N/A"}
                                  </>
                                )}
                              </div>
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                className="payment-history-expand-btn"
                                onClick={() => handleOpenPaymentFormPopup(payment)}
                                aria-label={isNewEntry ? "Create new payment entry" : "Expand payment form"}
                              >
                                <BsArrowsFullscreen />
                              </Button>
                            </div>
                          </div>
                        );
                      })
                    : null}
                </Card>
              </div>
            ) : null}
          </Col>
          )}
        </Row>
      </ErrorBoundary>
      {addressHistoryOpen && (
        <AddressHistoryModal
          show={addressHistoryOpen}
          onHide={() => setAddressHistoryOpen(false)}
          debtorID={account.account?.debtorID}
        />
      )}
      {showTranscriptsOpen && (
        <ShowTranscriptsModal
          show={showTranscriptsOpen}
          onHide={handleHideTranscripts}
          debtorID={account.account?.debtorID}
        />
      )}
      <Modal
        show={Boolean(pendingTemplateAccount)}
        onHide={handleCancelTemplateClaim}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Apply Claim Template</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {templateMessage || "The claim template is ready to apply."}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelTemplateClaim}>
            Cancel
          </Button>
          <Button onClick={handleConfirmTemplateClaim}>OK</Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showPaymentFormPopup}
        onHide={handleClosePaymentFormPopup}
        size="xl"
        centered
        className="payment-history-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Payment History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedPayment ? (
            <PaymentHistoryForm
              defaultFormData={selectedPayment}
              projects={projects}
              loadingProjects={loadingProjects}
              readOnly={isPaymentAdmin || isClaimCreator ? false : true}
              debtorID={account.account.debtorID}
              updateAccountFieldsAndActivities={updateAccountFieldsAndActivities}
            />
          ) : null}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CollectorClaimView;
